import {
    Button,
    CardContent,
    Paper,
    Grid, DialogActions, DialogContentText, DialogContent, DialogTitle, Dialog, Box, Typography, Stack,
} from "@mui/material";
import * as React from 'react';
import {useEffect, useState} from "react";
import SequenceOption from "./SequenceOption";
import {submitAnswerSequence, useApi} from "../api/Api";
import QuestionSequenceSolution from "./QuestionSequenceSolution";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useTranslation} from "react-i18next";
import QuestionDescription from "./QuestionDescription";

const QuestionSequence = ({question, fetchQuizStats, fetchCurrentQuestion}) => {
    const {t} = useTranslation();
    const api = useApi();

    const [openAlert, setOpenAlert] = useState(false);
    const [feedback, setFeedback] = useState("");
    const [correct, setCorrect] = useState();
    const [solution, setSolution] = useState();
    const [changeQuestion, setChangeQuestion] = useState(false);

    const [options, setOptions] = useState(question.answers.map((option, idx) =>
        Object.assign({}, option, {"order": idx})
    ));

    const handleClose = () => {
        setOpenAlert(false);
        setFeedback("");
        if (changeQuestion)
            fetchCurrentQuestion();
        fetchQuizStats();
    };

    useEffect(() => {
        if (!!feedback)
            setOpenAlert(true);
    }, [feedback]);

    useEffect(() => {
        console.log("options", options);
    }, [options]);

    const submitAnswer = () => {
        submitAnswerSequence(api, options)
            .then((response) => {
                let respData = response["data"];
                setCorrect(respData["correct"]);
                setFeedback(respData["feedback"]);
                setSolution(respData["solution"]);
                setChangeQuestion(respData["change_question"]);
            })
            .catch((error) => console.log(error));
    }

    const handleOnDragEnd = (result) => {
        if (!result.destination)
            return;
        const items = Array.from(options);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        items.forEach((option, index) => option.order = index);
        setOptions(items);
    }


    return (
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
            <Grid item>
                <Paper elevation={10} sx={{m: 1, maxWidth: 1000}}>
                    <CardContent>
                        {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_type")}: {t("sequence")}</Typography>*/}
                        {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_no")} {question["questionid"]}</Typography>*/}
                        {question["img"] ?
                            (
                                <Grid container justifyContent="center" alignItems="center" sx={{my: 2}}>
                                    <img src={question["img"]}
                                         style={{maxHeight: 350, maxWidth: "100%"}}
                                         alt={t("question")}/>
                                </Grid>
                            ) : (
                                <></>
                            )
                        }
                        <QuestionDescription description={question["description"]}/>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="answer" direction="horizontal">
                                {provided =>
                                    <Stack direction="row" spacing={1} {...provided.droppableProps}
                                           ref={provided.innerRef}>
                                        {options
                                            .map((option, index) =>
                                                <Draggable key={option.id} draggableId={option.id}
                                                           index={index}>
                                                    {provided => (
                                                        <div {...provided.draggableProps}
                                                             {...provided.dragHandleProps}
                                                             ref={provided.innerRef}>
                                                            <SequenceOption sx={{my: 1}}
                                                                            key={option.id}
                                                                            optionId={option.id}
                                                                            content={option.content}
                                                                            number={option.order + 1}
                                                                            showNumber={question["show_numbers"]}
                                                            />
                                                        </div>
                                                    )}
                                                </Draggable>
                                            )
                                        }
                                        {provided.placeholder}
                                    </Stack>
                                }
                            </Droppable>
                        </DragDropContext>
                        <Grid item textAlign="center" sx={{mt: 2}}>
                            <Button variant="contained" onClick={() => submitAnswer()}>{t("submit_answer")}</Button>
                        </Grid>
                    </CardContent>
                </Paper>
            </Grid>
            <Dialog
                open={openAlert}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {correct ? t("correct_answer") : t("incorrect_answer")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {feedback}
                        {solution === undefined ?
                            (
                                <></>
                            ) : (
                                <Box sx={{mt: 2}}>
                                    <Typography variant="h6">{t("solution")}</Typography>
                                    <Grid container>
                                        <QuestionSequenceSolution question={solution}/>
                                    </Grid>
                                </Box>
                            )
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t("close")}</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default QuestionSequence;
